import { FormGroup, FormParagraph } from '@ksyos/design-system';
import type { NotFunded } from '@common/interfaces/api/fundingResultsApi';
import { formatFundingExclusion } from '@frontend/components/pages/processes/adminProcessFinancials/utils/formatFundingExclusion';
import { getSelectedLanguage } from '@frontend/translate';
import type { FundingExclusion } from '../adminProcessDetailsTypes';

type NotFundedReasonProps = {
    fundingExclusion?: FundingExclusion;
    notFunded: NotFunded;
};

export function NotFundedReason({ notFunded, fundingExclusion }: NotFundedReasonProps) {
    const translate = getSelectedLanguage();

    const notFundedReasonValue = translate.notFundedReason[notFunded.notFundedReason] ?? '';

    return (
        <FormGroup label={translate.request.reasonNoInvoiceDecl}>
            <FormParagraph>{`${notFundedReasonValue} ${formatFundingExclusion(fundingExclusion)}`}</FormParagraph>
        </FormGroup>
    );
}
